var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.558 11.969l-5.04-4.973a2.54 2.54 0 00-1.798-.736h-6.48a2.563 2.563 0 00-2.56 2.56v15.36a2.563 2.563 0 002.56 2.56h11.52a2.563 2.563 0 002.56-2.56V13.79c0-.679-.278-1.344-.762-1.821zm-.899.912c.122.121.218.265.282.419H18.56a1.28 1.28 0 01-1.28-1.28V7.674c.122.061.237.135.34.234l5.04 4.973zM21.76 25.46H10.24a1.28 1.28 0 01-1.28-1.28V8.82c0-.707.573-1.28 1.28-1.28H16v4.48a2.563 2.563 0 002.56 2.56h4.48v9.6a1.28 1.28 0 01-1.28 1.28zm-.64-2.56c0 .355-.285.64-.64.64h-8.96a.638.638 0 01-.64-.64c0-.355.285-.64.64-.64h8.96c.355 0 .64.285.64.64zm0-3.2c0 .355-.285.64-.64.64h-8.96a.638.638 0 01-.64-.64c0-.355.285-.64.64-.64h8.96c.355 0 .64.285.64.64z",
    fill: "#fff"
  })));
}

export default SvgDocumentinline;